import { observer } from 'mobx-react';
import { BUTTON_VARIANTS } from '../../../../../../../../components/inputs/button-variants';
import FedexV2RegistrationModalLayout from '../fedex-v2-registration-modal-layout';
import FedexV2RegistrationAddressStep from '../steps/fedex-v2-registration-address-step';
import { IFedexV2RegistrationModalStepProps } from './fedex-v2-registration-modal-step-props';

const FedexV2RegistrationAddressModalStep: React.FC<IFedexV2RegistrationModalStepProps> = observer(({
    registration,
    modalVGroup,
}) => {
    const loading = registration.isLoading;

    return (
        <FedexV2RegistrationModalLayout
            registration={registration}
            buttons={[{
                text: 'Validate address',
                variant: BUTTON_VARIANTS.Primary,
                onClick: () => {
                    modalVGroup.validate();
                    if (modalVGroup.isValid()) {
                        registration.submitAddress();
                    }
                },
                hasLoader: true,
                isLoading: loading,
            }]}
        >
            <FedexV2RegistrationAddressStep address={registration.address} modalVGroup={modalVGroup} />
        </FedexV2RegistrationModalLayout>
    );
});

export default FedexV2RegistrationAddressModalStep;
